@if (IsHelpStyle()) {
  <i class="bi bi-question-circle ms-1" placement="{{placement}}" [ngbTooltip]="tooltipText1"
      [closeDelay]="url == '' ? 0 : 1000"></i>
  <ng-template #tooltipText1>
      <span [innerHTML]="labelName | translate: { url: url }"></span>
  </ng-template>
}

@if (IsAlertStyle()) {
  <i class="bi bi-exclamation-circle-fill text-danger me-2" placement="{{placement}}" [ngbTooltip]="tooltipText2"
      [closeDelay]="url == '' ? 0 : 1000"></i>
  <ng-template #tooltipText2>
      <span [innerHTML]="labelName | translate: { url: url }"></span>
  </ng-template>
}

@if (IsCloseableWrapperInfoStyle()) {
  <i class="bi bi-question-circle ms-1 text-primary" placement="{{placement}}" [ngbTooltip]="tooltipText3"
      [closeDelay]="url == '' ? 0 : 1000"></i>
  <ng-template #tooltipText3>
      <span [innerHTML]="labelName | translate: { url: url }"></span>
  </ng-template>
}
